import { useMutation, useQueryClient } from 'react-query';
import axios from '../../../utils/axios';
import { apiurl } from '../../../config/apiUrl';

const uploadVesselCostCentreQuery = (file) => {
  const formData = new FormData();
  formData.append('file', file);
  return axios.post(apiurl?.uploadVesselCostCentre, formData, {
    headers: {
      Accept: '*/*'
    },
    // Treat client/server error bodies as resolved so the modal can parse
    // structured update/duplicate messages instead of a generic network failure.
    // (Duplicate uploads sometimes return 400/409/500 with a usable body.)
    validateStatus: (status) => status >= 200 && status < 600
  });
};

const uploadVesselCostCentre = () => {
  const queryClient = useQueryClient();
  return useMutation(uploadVesselCostCentreQuery, {
    onSuccess: () => {
      queryClient.invalidateQueries('getvesselcostcenterlist');
    }
  });
};

export default uploadVesselCostCentre;
